<template>
  <v-card flat style="margin-top: 80px;">
    <v-data-table :headers="headers"
                  :items="devices"
                  fixed-header
                  :height="marginTop"
                  :item-class="() => 'fade-in'"
                  :loading="loading"
                  :items-per-page="50"
                  :options.sync="options"
                  :server-items-length="totalServerItems"
                  :footer-props="footerProps">
      <template v-slot:item.created_at="{ item }">
        {{ dateTimeToLocal(item.created_at) }}
      </template>
      <template v-slot:item.last_seen_at="{ item }">
        {{ dateTimeToLocal(item.last_seen_at) }}
      </template>
      <template v-slot:no-data>
        {{t({ s: 'searched', component: 'general' }) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Vue from 'vue'

import { deviceHeaders } from './headers'
import { apiGetBusinessDevicesPaginated } from '@/api'
import { mutations } from '@/state'

export default Vue.extend({
  name: 'DevicesTable',
  props: {
    marginTop: String,
    selectedBusiness: Object,
    tab: String,
    search: String
  },
  computed: {
    headers () {
      return deviceHeaders(this.t)
    }
  },
  data () {
    return {
      devices: [],
      loading: false,
      options: {},
      totalServerItems: 0,
      footerProps: { itemsPerPageOptions: [10, 25, 50] },
      queryParams: { direction: 'desc' },
      controller: null,
      timeout: null
    }
  },
  methods: {
    async initialize () {
      if (this.selectedBusiness.type !== 'enterprise' || this.tab !== 'devices') return
      if (this.controller) this.controller.abort()
      this.controller = new AbortController()

      this.devices = []
      this.loading = true

      const { sortDesc, page, itemsPerPage } = this.options
      if (sortDesc[0]) {
        this.queryParams.direction = sortDesc[0] ? 'asc' : 'desc'
      } else {
        this.queryParams.direction = 'desc'
      }
      const { id } = this.selectedBusiness
      const searchParam = this.search !== '' && typeof this.search === 'string' ? `&search=${this.search.toLowerCase()}` : ''

      const paginationConfig = {
        id,
        page,
        limit: itemsPerPage,
        direction: this.queryParams.direction,
        search: searchParam,
        signal: this.controller.signal
      }

      apiGetBusinessDevicesPaginated(paginationConfig)
        .then((response) => {
          this.devices = response?.data?.data
          if (response?.data?.pagination?.total_pages < page) this.options.page = 1
          this.totalServerItems = response?.data?.pagination?.total
          this.loading = false
        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        }).finally(() => this.gsapFadeIn())
    }
  },
  watch: {
    options: {
      handler () {
        this.initialize()
      },
      deep: true
    },
    search () {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.initialize()
      }, 500)
    },
    selectedBusiness () {
      this.initialize()
    }
  }
})
</script>
